import { IconButton } from '@llt-frontend/react-material-button';
import { InteractionEventTrigger } from '@blueshift-ui/telemetry';
import PropTypes from 'prop-types';
import React from 'react';
import SubjectDeletionConfirmation from './deletion-confirmation';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

//

function DeleteSubjectButton({
  className,
  onDelete,
  onDeleting,
  onError,
  subjectId,
  ...forwardedProps
}) {
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);

  const { t, ready: translationLoaded } = useTranslation('subjects/delete-button');

  //
  // Methods

  const openDeleteConfirmation = React.useCallback(() => {
    setDeleteConfirmationOpen(true);
  }, []);

  const closeDeleteConfirmation = React.useCallback(() => {
    setDeleteConfirmationOpen(false);
  }, []);

  //
  // Render

  if (!translationLoaded) {
    return null;
  }

  return (
    <>
      <InteractionEventTrigger
        analytics={{
          action: 'delete-subject',
          category: 'subject',
        }}
        element={IconButton}
        elementProps={{
          ...forwardedProps,
          className: classnames('delete-subject-button', className),
          onClick: openDeleteConfirmation,
          title: t('deleteSubject'),
        }}
      >
        delete_forever
      </InteractionEventTrigger>

      <SubjectDeletionConfirmation
        closeConfirmation={closeDeleteConfirmation}
        confirmationOpen={deleteConfirmationOpen}
        onDelete={onDelete}
        onDeleting={onDeleting}
        onError={onError}
        subjectId={subjectId}
      />
    </>
  );
}

DeleteSubjectButton.propTypes = {
  className: PropTypes.string,
  onDelete: PropTypes.func,
  onDeleting: PropTypes.func,
  onError: PropTypes.func,
  subjectId: PropTypes.string,
};

// Exports
// -------

export default DeleteSubjectButton;
